import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";

const steps = [
  {
    number: "01",
    title: "Discover",
    description: "Understand your goals, audience, and requirements through research.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M16 16l4.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: "02",
    title: "Plan",
    description: "Define scope, architecture, timeline, and technology stack.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4" y="5" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 3v4M16 3v4M4 10h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: "03",
    title: "Design",
    description: "Create wireframes and UI designs aligned with your brand identity.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 5h16v14H4V5Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 9h16" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    number: "04",
    title: "Develop",
    description: "Build with clean code, best practices, and scalable architecture.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M8 6L4 12L8 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16 6L20 12L16 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: "05",
    title: "Test",
    description: "Rigorous QA across devices, browsers, and performance benchmarks.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    number: "06",
    title: "Launch",
    description: "Deploy, monitor, and provide ongoing support for your website.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3v12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M8 11l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5 21h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

const WdevProcess: React.FC = () => {
  return (
    <section className="wdev-process" aria-labelledby="wdev-process-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="wdev-process-title" className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline">
            Our Web Development Process
          </h2>
        </AnimatedSection>

        <div className="wdev-process__timeline">
          <div className="wdev-process__line" aria-hidden="true" />
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              className="wdev-process__step"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              <div className="wdev-process__badge">{step.number}</div>
              <div className="wdev-process__card">
                <div className="wdev-process__icon">{step.icon}</div>
                <h3 className="wdev-process__title">{step.title}</h3>
                <p className="wdev-process__desc">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WdevProcess;
